export class SpinWheelMiniEntity {
  id?: number
  name?: string | null
  validFrom?: string
  validTo?: string
  minOrdersCount?: number
  isPrimary?: boolean
}
